module.exports = __webpack_public_path__ + "img/shedro.8a35b723.jpg";